@import '../../../../../constants/spacing.module.less';

.popover-content-container {
  height: 100%;
  max-height: 250px;
  overflow: hidden;
}

.locations-list-wrapper {
  flex: 1 1 auto;
  overflow: hidden auto;
  min-height: 0;
  max-height: 180px;
}

.locations-list {
  display: flex;
  flex-direction: column;
  gap: @space-4;
  padding: @space-0 @space-24 @space-8 @space-16;
  list-style: disc outside;
  margin: @space-0;
}

.location-item {
  display: list-item;
  color: var(--grey-800);
  font-size: @space-12;
  line-height: 1.5;
  word-break: break-word;
}

.popover-footer {
  flex: 0 0 auto;
  color: var(--grey-800);
  border-top: 1px solid var(--grey-300);
  padding: @space-12 @space-24;
  // Negative values here to avoid internal padding from InteractablePopover component
  margin: 0 -12px -12px;
  background-color: var(--white);
  position: relative;
  z-index: 1;
}
